export const mapNaNAsZero = (input: number): number => (isNaN(input) ? 0 : input);
